module.exports = __webpack_public_path__ + "static/rachel_400-c520b40d5304f0c08076b1e6fb2fbc24.jpg";